import { makeStyles, Theme, Typography } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { DropzoneOptions, useDropzone } from 'react-dropzone';
import { LogoProgress } from '@jupiterone/jupiter-web-toolkit';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    '&:focus': {
      outline: 'none',
    },
  },
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    padding: theme.spacing(2.5),
    borderWidth: 2,
    borderRadius: 2,
    borderColor: theme.palette.grey[300],
    borderStyle: 'dashed',
    backgroundColor: 'rgb(0, 0, 0, 0)',
    color: theme.palette.grey[400],
    outline: 'none',
    transition: 'border .24s ease-in-out',
    '&:hover': {
      cursor: 'pointer',
      borderColor: theme.palette.primary.main,
    },
  },
  secondaryText: {
    fontStyle: 'italic',
    fontSize: 14,
  },
  pendingText: {
    marginTop: theme.spacing(1),
  },
  showInput: {
    height: 1,
    width: 1,
    padding: 0,
    marginTop: theme.spacing(-0.375),
  },
  hideInput: {
    display: 'none',
  },
}));

interface Props extends DropzoneOptions {
  required?: boolean;
  primaryText: string;
  secondaryText: string;
  classes?: {
    root?: string;
    container?: string;
    primaryText?: string;
    secondaryText?: string;
  };
  pending?: boolean;
  pendingText?: string;
  children?: JSX.Element | undefined;
}

const DragDropFileUpload = ({
  required,
  primaryText,
  secondaryText,
  classes: propClasses = {},
  pending = false,
  pendingText = 'Uploading...',
  children,
  ...dropzoneOptions
}: Props) => {
  const classes = useStyles();

  const { getRootProps, getInputProps } = useDropzone({
    ...dropzoneOptions,
  });

  return (
    <div {...getRootProps()} className={clsx(classes.root, propClasses.root)}>
      <div className={clsx(classes.container, propClasses.container)}>
        {pending ? (
          <>
            <LogoProgress />
            <Typography
              align="center"
              color="primary"
              className={classes.pendingText}
            >
              {pendingText}
            </Typography>
          </>
        ) : (
          <>
            <Typography
              align="center"
              gutterBottom
              color="primary"
              className={propClasses.primaryText}
            >
              {primaryText}
            </Typography>
            <Typography
              align="center"
              color="primary"
              className={clsx(classes.secondaryText, propClasses.secondaryText)}
            >
              {secondaryText}
            </Typography>
            {children}
          </>
        )}
      </div>
      <input
        required={required}
        {...getInputProps()}
        style={{}}
        className={required ? classes.showInput : classes.hideInput}
      />
    </div>
  );
};
export default DragDropFileUpload;
